import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { removeNullFields } from "../../../../common/mapper";
import { PaymentStatus } from "../../common/constants";
import Filter from "../common/filter";
import TabBKMBelumLengkap from "./tabBKMBelumLengkap";
import TabBKMBelumRealisasi from "./tabBKMBelumRealisasi";
import TabBKMRealisasi from "./tabBKMRealisasi";
import * as R from "ramda";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import moment from "moment";

class TabBKM extends Component {
  constructor(props) {
    super(props);
    this.initialSearchData = {
      startDateBKM: moment().format("DD-MM-YYYY"),
      endDateBKM: moment().format("DD-MM-YYYY"),
    };
    this.initialPagination = {
      totalData: 1,
      page: 1,
      limit: 5,
    };
    this.state = {
      tabIndex: 0,
      loading: false,
      filterVisible: false,
      filterData: {},
      searchData: this.initialSearchData,
      submittedFilterData: {},
      skipNextPaginationFetch: false,
      dataTable: [],
      pagination: this.initialPagination,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.tabIndex !== this.state.tabIndex) {
      this.refetch({
        ...this.initialSearchData,
      });
    }
    const { submittedFilterData, pagination, skipNextPaginationFetch } =
      this.state;
    if (
      (prevState.pagination.page !== pagination.page ||
        prevState.pagination.limit !== pagination.limit) &&
      !this.state.skipNextPaginationFetch
    ) {
      this.fetchData(submittedFilterData, pagination.page, pagination.limit);
    }
    if (skipNextPaginationFetch) {
      this.setState({ skipNextPaginationFetch: false });
    }

    if (prevProps.kodeCabang?.value !== this.props.kodeCabang?.value) {
      this.handleResetPeriode();
      this.handleResetPagination();
      this.fetchData({
        ...submittedFilterData,
        ...this.initialSearchData,
      });
    }
  }

  fetchData = async (filter = {}, page = 1, limit = 5) => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: true,
      submittedFilterData: filter,
    }));
    const payload = {
      kodeCabang: this.props.kodeCabang?.value || "",
      paymentStatus: PaymentStatus.BELUM_LENGKAP,
      ...filter,
      operator: filter?.operator ? filter.operator : null,
      jenisRelasi: filter?.jenisRelasi ? filter.jenisRelasi : null,
      jenisDokumen: filter?.jenisDokumen ? filter.jenisDokumen : null,
      kodeKas: filter?.kodeKas ? filter.kodeKas : null,
    };

    if(this.state.tabIndex === 2){
      payload.startPaymentRealizationDate = payload.startDateBKM;
      payload.endPaymentRealizationDate = payload.endDateBKM;
      delete payload.startDateBKM;
      delete payload.endDateBKM;
    }
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getBKMData,
      menuName: "Transaksi Cash - BKM",
      setError: this.props.setError,
      args: {
        paramFilters: removeNullFields(payload),
        limit,
        page,
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const total = res.data.data.reduce(
        (sum, item) => sum + (item.paymentAmount || 0),
        0
      );
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: res.data.data,
        totalPayment: total,
        pagination: {
          ...prevValue.pagination,
          totalData: res.data.totalData,
        },
      }));
    }
    this.setState({ loading: false });
  };

  handleTabChange = (index) => {
    this.setState((prevValue) => ({
      ...prevValue,
      tabIndex: index,
      filterData: {},
      searchData: this.initialSearchData,
    }));
    this.handleResetPagination();
  };

  handlePeriodChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      searchData: {
        ...prevValue.searchData,
        [name]: moment(value).format("DD-MM-YYYY"),
      },
    }));
  };

  handleSubmitPeriod = () => {
    let { searchData } = this.state;
    
    const paymentDate = removeNullFields({
      startDateBKM: R.isNil(searchData.startDateBKM)
        ? null
        : searchData.startDateBKM,
      endDateBKM: R.isNil(searchData.endDateBKM)
        ? null
        : searchData.endDateBKM,
    });
  
    this.setState(
      (prev) => ({
        ...prev,
        pagination: {
          ...prev.pagination,
          page: 1,
        },
      }),
      () => {
        this.refetch(paymentDate);
      }
    );
  };


  handleSubmitFilter = async () => {
    // this.handleResetPagination();
    // this.handleResetPeriode();
    const tanggalPayment = removeNullFields(
      this.getPeriodInput(this.state.filterData?.tanggalPayment, "payment")
    );
    const tanggalDocRef1 = removeNullFields(
      this.getPeriodInput(this.state.filterData?.tanggalDokumenRef1, "docRef1")
    );
    const tanggalDocRef2 = removeNullFields(
      this.getPeriodInput(this.state.filterData?.tanggalDokumenRef2, "docRef2")
    );
    const data = this.state.filterData;
    const request = removeNullFields({
      startDateBKM: tanggalPayment?.tanggalAwal,
      endDateBKM: tanggalPayment?.tanggalAkhir,
      nomorBKM: data?.paymentCashId,
      jenisDokumen: data?.jenisDokumen?.value,
      nomorDokumenRef1: data?.nomorDokumenRef1,
      startTanggalDokumenRef1: tanggalDocRef1?.tanggalAwal,
      endTanggalDokumenRef1: tanggalDocRef1?.tanggalAkhir,
      nomorDokumenRef2: data?.nomorDokumenRef2,
      startTanggalDokumenRef2: tanggalDocRef2?.tanggalAwal,
      endTanggalDokumenRef2: tanggalDocRef2?.tanggalAkhir,
      kodeKas: data?.kodeKas?.value,
      namaOrangTransaksi: data?.namaOrangTransaksi,
      jenisRelasi: data?.jenisRelasi?.value,
      gunaMembayar: data?.gunaMembayar,
      keterangan: data?.keterangan,
      operator: data?.operator?.value,
      countCetakan: data?.count != null ? parseInt(data?.count) : null,
    });
    
    this.setState(
      (prev) => ({
        ...prev,
        pagination: {
          ...prev.pagination,
          page: 1,
        },
      }),
      async () => {
        await this.refetch(request);
      }
    );

    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: false,
      searchData: {
        startDateBKM: null,
        endDateBKM: null,
      },
    }));
  };

  handleClearFilter = () => {
    this.setState((prevValue) => ({ ...prevValue, filterData: {} }));
  };

  handleFilterValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleFilterDateChange = (key, name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [key]: {
          ...prevValue.filterData[key],
          [name]: value,
        },
      },
    }));
  };

  handleFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  refetch = async (filter = {}) => {
    const { page, limit } = this.state.pagination;

    const paymentStatus =
      this.state.tabIndex === 0
        ? PaymentStatus.BELUM_LENGKAP
        : this.state.tabIndex === 1
        ? PaymentStatus.BELUM_REALISASI
        : PaymentStatus.REALISASI;

    const finalFilter = { ...filter, paymentStatus };

    await this.fetchData(finalFilter, page, limit);

    this.setState((prev) => ({
      ...prev,
      submittedFilterData: finalFilter,
    }));
  };


  getPeriodInput = (data) => ({
    tanggalAwal: data?.tanggalAwal
      ? moment(data.tanggalAwal).format("DD-MM-YYYY")
      : null,
    tanggalAkhir: data?.tanggalAkhir
      ? moment(data.tanggalAkhir).format("DD-MM-YYYY")
      : null,
  });

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleResetPeriode = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      searchData: this.initialSearchData,
    }));
  };

  handleResetPagination = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: this.initialPagination,
      skipNextPaginationFetch: true,
    }));
  };

  handleRefresh = () => {
    const { page, limit } = this.state.pagination;
    const { submittedFilterData } = this.state;

    this.fetchData(submittedFilterData, page, limit);
  };


  render() {
    return (
      <div>
        <Tabs
          selectedIndex={this.state.tabIndex}
          onSelect={this.handleTabChange}
        >
          <TabList>
            <Tab>BELUM LENGKAP</Tab>
            <Tab>BELUM REALISASI</Tab>
            <Tab>REALISASI</Tab>
          </TabList>
          <TabPanel>
            <TabBKMBelumLengkap
              {...this.props}
              submittedFilter={this.state.submittedFilterData}
              state={this.state}
              onRefresh={this.handleRefresh}
              onPeriodChange={this.handlePeriodChange}
              onSubmitPeriod={this.handleSubmitPeriod}
              onShowFilter={this.handleFilterVisibility}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleRowsPerPage}
            />
          </TabPanel>
          <TabPanel>
            <TabBKMBelumRealisasi
              {...this.props}
              submittedFilter={this.state.submittedFilterData}
              state={this.state}
              onRefresh={this.handleRefresh}
              onPeriodChange={this.handlePeriodChange}
              onSubmitPeriod={this.handleSubmitPeriod}
              onShowFilter={this.handleFilterVisibility}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleRowsPerPage}
            />
          </TabPanel>
          <TabPanel>
            <TabBKMRealisasi
              {...this.props}
              submittedFilter={this.state.submittedFilterData}
              state={this.state}
              onRefresh={this.handleRefresh}
              onPeriodChange={this.handlePeriodChange}
              onSubmitPeriod={this.handleSubmitPeriod}
              onShowFilter={this.handleFilterVisibility}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleRowsPerPage}
            />
          </TabPanel>
        </Tabs>
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
        {this.state.filterVisible && (
          <Filter
            {...this.props}
            tab="BKM"
            paymentStatus={"REALISASI"}
            data={this.state.filterData}
            visible={this.state.filterVisible}
            onClickClose={this.handleFilterVisibility}
            onValueChange={this.handleFilterValueChange}
            onDateChange={this.handleFilterDateChange}
            onSubmit={this.handleSubmitFilter}
            onClear={this.handleClearFilter}
          />
        )}
      </div>
    );
  }
}

export default TabBKM;
